import React, { useState } from "react";
import { connect } from "react-redux";
import { ReactComponent as CloseIcon } from "assets/images/icons/close.svg";
import { clearOnboarding } from "redux/actions/onboardingActions";
import Modal from "utils/Modal/Modal";

const Disclaimer = ({ isLogin, history, clearOnboarding }) => {
	const [showModal, setShowModal] = useState(false);

	const toggle = () => setShowModal((prev) => !prev);

	const goToOnboarding = () => {
		clearOnboarding();
		history.push("/onboarding");
	};

	const title = isLogin
		? "Don’t have an account?"
		: "Already have an account?";
	const linkText = isLogin ? "Sign Up" : "Login";

	const redirect = () =>
		isLogin ? goToOnboarding() : history.push("/auth/login");

	return (
		<>
			<div
				className="fw-bold flex__end mb-2 text--primary pointer"
				onClick={toggle}
			>
				<p className="small-circle mb-1 me-2 smallest bg--primary">i</p>
				<span className="fw-bold">Disclaimer</span>
			</div>

			<span className="">
				{title}{" "}
				<span
					className="text--primary pointer fw-bold "
					onClick={redirect}
				>
					{linkText}
				</span>
			</span>

			{showModal && (
				<Modal show={true}>
					<div className="p-4">
						<div className="flex__between border-bottom pb-2">
							<span className="heading3 ">Disclaimer</span>
							<CloseIcon
								className="pointer"
								width={15}
								onClick={toggle}
							/>
						</div>

						<p className=" pt-4 text-justify">
							Carefully consider your investment objectives, the
							risks, charges and expenses involved in Investing in
							the Nigerian stock market. It’s important to note
							that the same way profits can be made in the market,
							losses can also be made as well. This therefore
							implies that a good knowledge of the market is
							required before actively investing in the stock
							market. Kindly check through the resources available
							on the MeriTrade website which will educate you on
							how to trade profitably in the stock market”. Market
							volatility, trading volumes, system performance and
							other factors may delay system access and response
							times. Execution price, speed and liquidity are
							affected by many factors, including market
							volatility, size and type of order.
						</p>
					</div>
				</Modal>
			)}
		</>
	);
};

export default connect(null, { clearOnboarding })(Disclaimer);
